export const MenuDisplayContext = {
  CUSTOMER: "Customer",
  NON_CUSTOMER: "NonCustomer"
} as const

export type MenuDisplayContext = (typeof MenuDisplayContext)[keyof typeof MenuDisplayContext]
